import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import { uploadMultiPartFiles, saveOutputTemplateByType, getOutputTemplateByType } from '../../../App/actions';
import TitleFrom from '../../../../components/common/TitleFrom';
import { UsageDetailSearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  DragDropConfigExportTemplate,
  ModalWithItem,
} from '../../../../components/common';
import { tabelColumnExportUsageDetail, sortUsageDetail } from '../../constants';
import { getUsageDetail, getAllUsageDetail, onResetDefaultData } from '../../actions';
import { makeGetListUsageDetail, makeGetListAllUsageDetail } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelUsageDetail';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfUsageDetail';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;

class UsageDetail extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {
      startDate: moment()
        .startOf('month')
        .format('YYYY-MM-DD'),
      endDate: moment()
        .endOf('month')
        .format('YYYY-MM-DD'),
    },
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listUsageDetail: [],
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listUsageDetail: props.listUsageDetail,
      totalCount: getPageTotalCount({ ...state, items: props.listUsageDetail }),
    };
  }

  componentDidMount() {
    const {
      permissions: { modeGetUsageDetailReport },
      onResetDefaultData,
    } = this.props;
    if (modeGetUsageDetailReport) {
      this.doGetOutputTemplateByType();
      onResetDefaultData('listUsageDetail');
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetListUsageDetail();
    });
  };

  onPageChange = pageChange => {
    const { page } = this.state;
    if (page === pageChange) return '';
    return this.setState({ page: pageChange }, () => this.doGetListUsageDetail());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetListUsageDetail());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetListUsageDetail();
    });
  };

  doGetListUsageDetail = () => {
    const { filter, page, size, sorted } = this.state;
    const { getUsageDetail } = this.props;
    const payload = {
      page: page + 1,
      size,
      filter,
      sort:
        !isEmpty(sorted) && sortUsageDetail[sorted.sortCol] ? sortUsageDetail[sorted.sortCol][sorted.sortDir] : null,
    };
    this.setState({ isSearching: true });
    getUsageDetail(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAlllistUsageDetail = cb => {
    const { filter, sorted } = this.state;
    const { getAllUsageDetail } = this.props;
    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter,
      sort: !isEmpty(sorted) ? sortUsageDetail[sorted.sortCol][sorted.sortDir] : null,
    };
    getAllUsageDetail(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAlllistUsageDetail(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { listAllUsageDetail, t } = this.props;
        convertJson2Pdf({
          data: listAllUsageDetail,
          t,
          title: t('reportPage:sidebar.usageDetail').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.usageDetail')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          columnsTable: tableColumnsOutput,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAlllistUsageDetail(() => {
      const { listAllUsageDetail, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf } = this.state;

      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'GET_USAGE_DETAIL_REPORT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.usageDetail')}`,
          emailBody,
        },
        ['type']
      )})}"}`;
      const formData = new FormData();

      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.usageDetail')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllUsageDetail,
            t,
            columns: tableColumnsOutput,
            listOptionFields: {
              recordIndicator: 'usageRecIndicator',
              status: 'usageRecStatus',
            },
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllUsageDetail,
          t,
          title: t('reportPage:sidebar.usageDetail').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.usageDetail')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          columnsTable: tableColumnsOutput,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.usageDetail')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }

      formData.append('graphql', query);
      // formData.append('file', blobToFile(pdfFile, 'attachment'));
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('USAGE_DETAIL_REPORT', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportUsageDetail,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listUsageDetail,
      emails,
      filter,
      exportColumnsSave,
      isOpenModalExportConfig,
    } = this.state;
    const {
      listAllUsageDetail,
      t,
      permissions: { modeGetUsageDetailReport, modeDownloadReport, modeGetMailReport },
    } = this.props;
    if (!modeGetUsageDetailReport) return '';
    const exportColumns = exportColumnsSave || {};
    tableColumnsOutput = exportColumns?.targetFields?.items || [];
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[
            { name: t('label.report'), url: RouteNames.report.path },
            { name: t('reportPage:sidebar.usageDetail') },
          ]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.usageDetail')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <UsageDetailSearchForm onSubmit={this.onHandleSubmitSearch} defaultFilter={filter} />
              </div>
              <div>
                <div className="mt-3 col-md-12 row mb-4 pt-3 pb-3">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    {/* {t('label.outputConfig')} */}
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet="USAGE DETAIL"
                        multiDataSet={convertJson2Sheet({
                          data: listAllUsageDetail,
                          t,
                          title: t('reportPage:sidebar.usageDetail').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.usageDetail')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listUsageDetail}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput}
                  data={listUsageDetail && listUsageDetail.length ? listUsageDetail : []}
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

UsageDetail.propTypes = {
  getUsageDetail: PropTypes.func,
  getAllUsageDetail: PropTypes.func,
  listAllUsageDetail: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.any), PropTypes.objectOf(PropTypes.any)]),
};

UsageDetail.defaultProps = {
  getUsageDetail: () => {},
  getAllUsageDetail: () => {},
  listAllUsageDetail: [],
};

const mapStateToProps = createStructuredSelector({
  listUsageDetail: makeGetListUsageDetail() || [],
  listAllUsageDetail: makeGetListAllUsageDetail() || [],
});
export default withTranslation('common')(
  connect(mapStateToProps, {
    getUsageDetail,
    getAllUsageDetail,
    uploadMultiPartFiles,
    saveOutputTemplateByType,
    getOutputTemplateByType,
    onResetDefaultData,
  })(UsageDetail)
);
